import { useTranslation } from 'react-i18next'
import { Robot } from 'features/main/robot'

import c from './ban-screen.module.scss'

export const BanScreen = ({ reason }) => {
    const { t } = useTranslation()
    const handleSupport = () => {
        const supportBotUrl = 'https://t.me/ggturbo_support_bot'
        try {
            if (window?.Telegram?.WebApp?.openTelegramLink) {
                window.Telegram.WebApp.openTelegramLink(supportBotUrl)
            } else {
                window.open(supportBotUrl, '_blank')
            }
        } catch (e) {
            window.open(supportBotUrl, '_blank')
        }
    }

    return (
        <div className={c.component}>
            <div className={c.content}>
                <h3 className={c.title}>{t('ban.title')}</h3>
                {reason && (
                    <p className={c.reason}>{t('ban.reason', { reason })}</p>
                )}
                <p className={c.text}>
                    {t('ban.text')}{' '}
                    <button onClick={handleSupport} className={c.supportLink}>
                        {t('ban.support')}
                    </button>
                </p>
            </div>
            <Robot state={0} />
        </div>
    )
}
